// Helper for alarm indicator in different measurers

export function normalizeAlarmValue(value, min, max) {
    if (value === null || value === undefined) {
        console.warn('Alarm value is null or undefined, cannot normalize.')
        return null;
    }
    const clampedValue = Math.max(min, Math.min(max, value));
    const normalized = (clampedValue - min) / (max - min);
    // console.log(`Normalizing alarm value: ${value} to ${normalized} (min: ${min}, max: ${max})`);
    return normalized;
}

// check if its possible to get a generic function for all measurers type GetAlarmStyle; 